import { render, staticRenderFns } from "./Bando26Fase8.vue?vue&type=template&id=57913c01&scoped=true"
import script from "./Bando26Fase8.vue?vue&type=script&lang=js"
export * from "./Bando26Fase8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57913c01",
  null
  
)

export default component.exports